import React from 'react';
import {Activities, Card, Icon} from 'components';
import {size, openPopup, useDragStart, useGrabbed, over} from 'helpers';
import {reschedule} from 'store/activities';
import {resolve} from 'store/calendar';
import css from './body-calendar.module.scss';

export function BodyCalendar(props) {
  const { activity, contextDate, editable, disabled, time, subroutines, occurance, isAllDay } = props;
  const { id, name } = activity;
  return (
    <>
      <Card.Body className={css.body}>
        <Card.Text>{ name }</Card.Text>
        { !isAllDay &&
          <>
            { size(subroutines) > 0 &&
              <Activities.SubRoutinesChecklist {...props} />
            }
          </>
        }
      </Card.Body>
      { editable && !isAllDay &&
        <>
          <Handle {...{type: 'top-handle', id, occurance, contextDate, time}} />
          <Handle {...{type: 'bottom-handle', id, occurance, contextDate, time}} />
        </>
      }
      { editable && !disabled &&
        <Card.Toolbar aria-haspopup className={css.toolbar}>
          <Icon name="menu" onClick={openPopup(Activities.Menu, {...props, edit: props.attributes.onClick})} />
        </Card.Toolbar>
      }
    </>
  );
}

const Handle = (props) => {
  const grabbed = useGrabbed();
  const handlers = {
    ...useDragStart(props),
    onDrag() {
      const {clientY, offset, type, target} = grabbed;
      if (type === 'top-handle') {
        grabbed.start = resolve(clientY + offset.y);
        grabbed.end = resolve(clientY + offset.y + target.parentNode.offsetHeight);
      } else if (type === 'bottom-handle') {
        grabbed.start = resolve(clientY + offset.y - target.parentNode.offsetHeight);
        grabbed.end = resolve(clientY + offset.y);
      }
    }
  };
  handlers.onDragEnd = over(handlers.onDragEnd, () => {
    reschedule({
      ...props,
      date: props.contextDate,
      time: grabbed.start.time,
      duration: Math.max(0, grabbed.end.minutes - grabbed.start.minutes) || null
    });
  });
  return (
    <div className={css[props.type]} {...handlers} />
  );
};
